import {
  CodexCalculatorControls,
  CodexCalculatorPortraitBlock,
  type CodexCalculatorColumnProps,
} from "./-codex.damageCalculator.fields";

export type { CodexCalculatorColumnProps };

export function CodexCalculatorUnitSection({
  label,
  player,
  unitKind,
  unitKinds,
  terrain,
  displayHp,
  onUnitKindChange,
  onTerrainChange,
  onDisplayHpChange,
}: CodexCalculatorColumnProps & { label: string }) {
  return (
    <div className="flex w-full flex-col gap-2">
      <h3 className="text-sm font-semibold">{label}</h3>
      <div className="flex items-start gap-3">
        <CodexCalculatorPortraitBlock
          player={player}
          unitKind={unitKind}
          terrain={terrain}
          displayHp={displayHp}
        />
        <CodexCalculatorControls
          unitKind={unitKind}
          unitKinds={unitKinds}
          terrain={terrain}
          displayHp={displayHp}
          onUnitKindChange={onUnitKindChange}
          onTerrainChange={onTerrainChange}
          onDisplayHpChange={onDisplayHpChange}
        />
      </div>
    </div>
  );
}

export function CodexCalculatorColumn({
  player,
  unitKind,
  unitKinds,
  terrain,
  displayHp,
  onUnitKindChange,
  onTerrainChange,
  onDisplayHpChange,
}: CodexCalculatorColumnProps) {
  return (
    <div className="flex w-40 flex-col items-center gap-3 sm:w-44">
      <CodexCalculatorPortraitBlock
        player={player}
        unitKind={unitKind}
        terrain={terrain}
        displayHp={displayHp}
      />
      <CodexCalculatorControls
        unitKind={unitKind}
        unitKinds={unitKinds}
        terrain={terrain}
        displayHp={displayHp}
        onUnitKindChange={onUnitKindChange}
        onTerrainChange={onTerrainChange}
        onDisplayHpChange={onDisplayHpChange}
      />
    </div>
  );
}
